export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50 pt-20 pb-8 px-6">
      <div className="max-w-[1240px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-16 border-b border-background-50/10">
          <div className="lg:col-span-5 text-center lg:text-left">
            <div className="flex items-center gap-3 mb-6 justify-center lg:justify-start">
              <img
                src="https://static.readdy.ai/image/a35c297e288f6b366b89cee76947f7c3/6fa04e5f89eb63777ba3d39f2af83c0d.png"
                alt="anniversary-car-rental"
                className="w-20 h-20 object-contain brightness-200"
              />
              <div className="leading-tight">
                <p className="font-heading text-xl tracking-[0.2em] text-background-50">Anniversary Car</p>
                <p className="text-[10px] tracking-[0.3em] text-accent-300">— Event Rental —</p>
              </div>
            </div>
            <p className="text-sm text-background-50/70 leading-loose max-w-md mx-auto lg:mx-0">
              スーパーカーの黄金期を締めくくった、最終にして至高の傑作。<br/>
圧倒的な存在感でイベントを彩るプレミアム展示など各種イベントへの貸出。
            </p>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-[10px] tracking-[0.4em] uppercase text-accent-300 mb-5">
              <a href="#cars" className="cursor-pointer">Navigation</a>
            </h4>
            <ul className="space-y-3 text-sm text-background-50/70">
              <li><a href="#home" className="hover:text-accent-300 cursor-pointer">Home</a></li>
              <li><a href="#about" className="hover:text-accent-300 cursor-pointer">About</a></li>
              <li><a href="#pricing" className="hover:text-accent-300 cursor-pointer">Pricing</a></li>
              <li><a href="#access" className="hover:text-accent-300 cursor-pointer">Access</a></li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="text-[10px] tracking-[0.4em] uppercase text-accent-300 mb-5">
              <a href="#access" className="cursor-pointer">Contact</a>
            </h4>
            <ul className="space-y-4 text-sm text-background-50/80">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-accent-300 mt-0.5"></i>
                <span>神奈川県秦野市曽屋1175</span>
              </li>
              <li>
                <a href="tel:+817069422157" className="flex items-center gap-3 hover:text-accent-300 cursor-pointer">
                  <i className="ri-phone-line text-accent-300"></i>
                  <span>070-6942-2157</span>
                </a>
              </li>
              <li>
                <a href="mailto:	info@anniversary-car-rental.com" className="flex items-center gap-3 hover:text-accent-300 cursor-pointer">
                  <i className="ri-mail-line text-accent-300"></i>
                  <span className="break-all">	info@anniversary-car-rental.com</span>
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-time-line text-accent-300"></i>
                <span>9:00 - 18:00 (年中無休)</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 text-center text-xs text-background-50/60">
          <p className="whitespace-nowrap">© 2026 Anniversary Car Event Rental. All rights reserved.</p>
        </div>

        <div className="text-center mt-8">
          <p className="text-[10px] tracking-[0.3em] uppercase text-background-50/40">
            Lamborghini Countach 25th Anniversary <br/>Event Rental
          </p>
        </div>
      </div>
    </footer>
  );
}